<template>
  <div class="calendar-switch">
    <div
      v-for="t in typeList"
      :key="t.key"
      class="calendar-switch-item"
      :class="{
        'active': t.key === viewType
      }"
      @click="changeViewType(t)"
    >
      {{ t.label }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalendarSwitch',
  props: {
    viewType: String
  },
  data () {
    return {
      typeList: [
        {
          label: '日',
          key: 'days'
        },
        {
          label: '周',
          key: 'week'
        },
        {
          label: '月',
          key: 'month'
        },
        {
          label: '年',
          key: 'year'
        }
      ]
    }
  },
  methods: {
    changeViewType (t) {
      this.$emit('change', t.key)
      this.$analysis.track(`切换${t.label}视图_日程安排/工作台模块`)
    }
  }
}
</script>
<style lang="stylus">
.calendar-switch
  display inline-flex
  flex-wrap nowrap
  border 1px solid #eaeaea
  border-radius 20px
  &-item
    width 36px
    height 30px
    line-height 30px
    cursor pointer
    text-align center
    border-left 1px solid #eaeaea
    &:first-child
      border-left 0
      &.active
        border-top-left-radius 20px
        border-bottom-left-radius 20px
    &:last-child.active
      border-top-right-radius 20px
      border-bottom-right-radius 20px
    &.active
      background-color #fcfcfb
      color #ed6c00
      font-weight 500
      box-shadow 0 1px 1px 0 rgba(0,0,0,.05), inset 0 1px 2px 0 rgba(0,0,0,.05)
</style>
